import * as React from 'react';

import * as styles from './Labels.css';
import { ILabelProps, Label } from '@cian/ui-kit';

interface ILabelsProps {
  labels: ILabelProps[];
}

export const Labels: React.FC<ILabelsProps> = ({ labels }) => {
  const labelsContainerRef = React.useRef<HTMLDivElement>(null);
  const innerLabelsContainerRef = React.useRef<HTMLDivElement>(null);
  const [displayLabels, setDisplayLabels] = React.useState<ILabelProps[]>([]);

  React.useEffect(() => {
    if (labels.length && labelsContainerRef.current && innerLabelsContainerRef.current) {
      const labelsContainer = labelsContainerRef.current;
      const innerLabelsContainer = innerLabelsContainerRef.current;

      const labelsContainerWidth = labelsContainer.offsetWidth;
      const innerLabelsContainerWidth = innerLabelsContainer.offsetWidth;

      setDisplayLabels(innerLabelsContainerWidth > labelsContainerWidth ? [labels[0]] : labels);
    }
  }, [labels]);

  if (!labels.length) {
    return null;
  }

  return (
    <div className={styles['container']} ref={labelsContainerRef}>
      <div style={{ visibility: 'hidden' }} className={styles['inner-labels']} ref={innerLabelsContainerRef}>
        {labels.map((label, index) => (
          <Label key={index} {...label} />
        ))}
      </div>
      <div className={styles['labels']}>
        {displayLabels.map((label, index) => (
          <Label key={index} {...label} />
        ))}
      </div>
    </div>
  );
};
